/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A GC-rich (G-heavy) window gives a positive skew; a C-heavy window gives a negative skew.`)
};

const es_gcskew_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una ventana rica en GC (con predominio de G) da un sesgo positivo; una ventana con predominio de C da un sesgo negativo.`)
};

const de_gcskew_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein GC-reiches (G-lastiges) Fenster ergibt einen positiven Skew; ein C-lastiges Fenster ergibt einen negativen Skew.`)
};

const nl_gcskew_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een GC-rijk (G-zwaar) venster geeft een positieve skew; een C-zwaar venster geeft een negatieve skew.`)
};

const fr_gcskew_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fenêtre riche en GC (riche en G) donne un biais positif ; une fenêtre riche en C donne un biais négatif.`)
};

const it_gcskew_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una finestra ricca di GC (con più G) dà uno skew positivo; una finestra ricca di C dà uno skew negativo.`)
};

const pt_br2_gcskew_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma janela rica em GC (com excesso de G) dá um skew positivo; uma janela com excesso de C dá um skew negativo.`)
};

const pt_gcskew_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma janela rica em GC (com excesso de G) dá uma assimetria positiva; uma janela rica em C dá uma assimetria negativa.`)
};

const ja_gcskew_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GCに富む（G優位の）窓は正のスキューを示し、C優位の窓は負のスキューを示します。`)
};

const zh_gcskew_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`富含 G 的 GC 富集窗口给出正偏斜；富含 C 的窗口给出负偏斜。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_ex1", locale)
	if (locale === "en") return en_gcskew_ex1(inputs)
	if (locale === "es") return es_gcskew_ex1(inputs)
	if (locale === "de") return de_gcskew_ex1(inputs)
	if (locale === "nl") return nl_gcskew_ex1(inputs)
	if (locale === "fr") return fr_gcskew_ex1(inputs)
	if (locale === "it") return it_gcskew_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_ex1(inputs)
	if (locale === "pt") return pt_gcskew_ex1(inputs)
	if (locale === "ja") return ja_gcskew_ex1(inputs)
	return zh_gcskew_ex1(inputs)
};